import { render } from "./AccountBadge.vue?vue&type=template&id=24ffbffd&scoped=true"
import script from "./AccountBadge.vue?vue&type=script&lang=js"
export * from "./AccountBadge.vue?vue&type=script&lang=js"

import "./AccountBadge.vue?vue&type=style&index=0&id=24ffbffd&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ffbffd"]])

export default __exports__